import type { ReactNode } from "react";

import * as React from "react";

import AnnouncementMessage from "@/features/announcements/AnnouncementMessage";
import { useExperimentDetails } from "@/features/experiments/tabs/hooks/useExperimentDetails";
import PageHeader from "@replo/design-system/components/PageHeader";

import { TabMenu } from "./tabs/TabMenu";

type ExperimentsLayoutProps = {
  children: ReactNode;
  headerTitle?: string;
  headerActions?: ReactNode;
  showStatus?: boolean;
  headerTitleComponent?: ReactNode;
  onBackClick?: () => void;
};

export const ExperimentsLayout = ({
  headerTitle,
  headerTitleComponent,
  children,
  headerActions,
  onBackClick,
}: ExperimentsLayoutProps) => {
  const { experiment } = useExperimentDetails();

  return (
    <div className="relative flex w-full flex-col gap-4 overflow-hidden px-6">
      <div className="flex flex-col gap-2.5">
        <PageHeader
          title={headerTitle}
          onBackClick={onBackClick}
          actions={headerActions}
          titleComponent={headerTitleComponent}
          divider={false}
        >
          {!experiment && <AnnouncementMessage tags={["A/B Testing"]} />}
        </PageHeader>
        {experiment && <TabMenu />}
      </div>
      {children}
    </div>
  );
};
